// Navigation service for use outside React components (e.g., axios interceptors)
import { NavigateFunction } from 'react-router-dom';

class NavigationService {
    private navigate: NavigateFunction | null = null;
    private toastSetter: ((toast: { show: boolean; message: string; type: 'success' | 'error' | 'info' | 'warning' }) => void) | null = null;

    setNavigate(navigate: NavigateFunction) {
        this.navigate = navigate;
    }

    setToastSetter(setter: (toast: { show: boolean; message: string; type: 'success' | 'error' | 'info' | 'warning' }) => void) {
        this.toastSetter = setter;
    }

    navigateTo(path: string) {
        if (this.navigate) {
            this.navigate(path);
        }
    }

    showToast(message: string, type: 'success' | 'error' | 'info' | 'warning' = 'error') {
        if (this.toastSetter) {
            this.toastSetter({ show: true, message, type });
        }
    }
}

export const navigationService = new NavigationService();
